import React from 'react'
import { showCurrencyFormat } from '../../../../utils';
import NumericLabel from 'react-pretty-numbers';
import { gaTelesisInstance } from '../../../../shared_elements/components';

export default function ClosingBalanceDetails({ data }) {

    return (
        <div className='cshflw-clsng'>
            <ul>
                {data?.rental ?
                    <li>
                        <span>
                            <div className='amnt-hd'>Rental  </div>
                            <NumericLabel className='amnt-val' params={showCurrencyFormat()}>
                                {data.rental || 0}
                            </NumericLabel>
                        </span>
                    </li> : null
                }
                {data?.reserve ?
                    Object.keys(data.reserve).map(item => (
                        <li>
                            <span>
                                <div className='amnt-hd'>{item}  </div>
                                <NumericLabel  params={showCurrencyFormat()}>
                                    {data?.reserve[item] || 0}
                                </NumericLabel>
                            </span>
                        </li>
                    ))
                    : null}
                    {data?.security_deposit ?
                    <li>
                        <span>
                            <div className='amnt-hd'>Security Deposit  </div>
                            <NumericLabel className='amnt-val' params={showCurrencyFormat()}>
                                {data.security_deposit || 0}
                            </NumericLabel>
                        </span>
                    </li> : null
                }
                {data?.penalty ?
                    <li>
                        <span>
                            <div className='amnt-hd'>Penalty  </div>
                            <NumericLabel className='amnt-val' params={showCurrencyFormat()}>
                                {data.penalty || 0}
                            </NumericLabel>
                        </span>
                    </li> : null}
                    {data?.management_fee && gaTelesisInstance?
                    <li>
                        <span>
                            <div className='amnt-hd'>Management Fee  </div>
                            <NumericLabel className='amnt-val' params={showCurrencyFormat()}>
                                {data.management_fee || 0}
                            </NumericLabel>
                        </span>
                    </li> : null}
            </ul>

        </div>
    )
}
